import type { ActivityStatus } from "@octopusdeploy/octopus-server-client";
import { getStatusIcon } from "~/areas/tasks/components/Task/TaskLog/TaskLogUtil";
export const TaskStatusIcon = (props: {
    status: ActivityStatus | undefined;
}) => getStatusIcon(props.status || "");
